import { Controller } from '@hotwired/stimulus'
import ClipboardJS from 'clipboard'

export default class extends Controller {
  static values = {
    successMessage: { type: String, default: 'Copied!' },
    errorMessage: {
      type: String,
      default: 'Error Copying!'
    }
  }

  connect () {
    this.clipboard = new ClipboardJS(this.element)

    this.clipboard.on('success', e => this.showTooltip(this.successMessageValue))
    this.clipboard.on('error', e => this.showTooltip(this.errorMessageValue))
  }

  showTooltip (message) {
    const tooltip = document.createElement('div')
    tooltip.className = 'clipboard-tooltip absolute py-1 px-2'
    tooltip.innerText = message

    this.element.style.position = 'relative'
    tooltip.style.top = '-30px'
    tooltip.style.left = '50%'
    tooltip.style.transform = 'translateX(-50%)'
    tooltip.style.zIndex = '1000'

    this.element.appendChild(tooltip)

    setTimeout(() => {
      tooltip.remove()
    }, 2000)
  }

  disconnect () {
    this.clipboard.destroy()
  }
}
